import React from "react";
import { Link } from "react-router-dom";
import PageTopSlider from "../components/PageTopSlider";
import GalleryViewer from "../components/GalleryViewer";
import ReviewsSlider from "../components/ReviewsSlider";
import ContactForm from "../components/ContactForm";
import SEO from "../components/SEO";

export default function Termografi() {
  const applications = [
    {
      title: "Dårlig eller mangelfuld isolering",
      desc: "Afslører præcist manglende eller sammenfaldet isolering i hulmure, skunk, lofter og terrændæk.",
      icon: "fa-layer-group",
    },
    {
      title: "Utætte vinduer og døre",
      desc: "Finder træk og utætte lister omkring vindues- og dørkarme, hvor kostbar varme siver ud.",
      icon: "fa-door-open",
    },
    {
      title: "Kuldebroer i konstruktionen",
      desc: "Lokaliserer byggetekniske kuldebroer ved sokkel, samlinger og overliggere, der kan give kondens.",
      icon: "fa-snowflake",
    },
    {
      title: "Lækager i rør eller varmesystemer",
      desc: "Kan spore skjulte rørføringer, lækager i gulvvarme og ubalancer i radiatorsystemet.",
      icon: "fa-faucet-drip",
    },
    {
      title: "Problemer med ventilation eller fugt",
      desc: "Kortlægger fugtområder og uønsket luftindtrængning, der udgør en risiko for skimmelsvamp.",
      icon: "fa-wind",
    },
  ];

  return (
    <div className="bg-[#FAF9F6] text-stone-800">
      <SEO
        title="Termografi | ET Danmark ApS"
        description="Hvad er termografi af bygninger? Termografi af bygninger er en metode, hvor man ved hjælp af et specielt varmekamera kan se temperaturforskelle på en bygnings overflader. Kameraet registrerer infrarød stråling, som ikke kan ses med det blotte øje, og omsætter det til farvebilleder, hvor varme og kulde fremstår tydeligt. Med termografi kan man hurtigt og præcist afsløre områder, hvor varmen slipper ud, eller hvor kulde trænger ind. Det bruges typisk til at finde:"
        canonical="https://etdanmark.com/termografi"
        ogImage="https://assets.auxodev.dk/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07589_527e30c7.jpg"
      />
      {/* 1. TOP SLIDER HERO */}
      <PageTopSlider
        title="Termografi"
        subtitle="Med termografi får du et tydeligt billede af, hvor varmen forsvinder fra din bolig eller virksomhed. Vores infrarøde varmekamera afslører kuldebroer, utætheder og isoleringsfejl."
        badge="Infrarød termografisk måling"
        breadcrumbs={[
          { label: "Forside", to: "/" },
          { label: "Ydelser", to: "/#ydelser" },
          { label: "Termografi" },
        ]}
        priceBadge="Fra 2.500 kr. inkl. moms"
        actions={
          <>
            <Link
              to="/prisberegner"
              className="px-6 py-3 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-sm shadow-md transition-all flex items-center gap-2"
            >
              <i className="fa-solid fa-calculator text-xs" aria-hidden="true"></i>
              <span>Beregn pris</span>
            </Link>
            <a
              href="tel:+4542499595"
              className="px-6 py-3 rounded-full bg-white/15 hover:bg-white/25 border border-white/30 text-white font-bold text-sm backdrop-blur-xs transition-all flex items-center gap-2"
            >
              <i className="fa-solid fa-phone text-emerald-300 text-xs" aria-hidden="true"></i>
              <span>Ring 42 49 95 95</span>
            </a>
          </>
        }
        image={{
          url: "https://assets.auxodev.dk/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07546.jpg",
          alt: "Termografi bygningsundersøgelse",
        }}
      />

      {/* RÅDGIVNING & INTRODUKTION */}
      <section className="py-14 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7 space-y-5">
              <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight">
                Synliggør det usynlige med varmekamera
              </h2>

              <div className="space-y-3 text-stone-600 text-sm sm:text-base leading-relaxed">
                <p>
                  Termografi er et effektivt værktøj til at forbedre bygningers energieffektivitet, reducere varmetab og dokumentere, at energikrav bliver overholdt. Undersøgelsen udføres typisk i fyringssæsonen, hvor temperaturforskellen mellem ude og inde er størst.
                </p>
                <p>
                  Rapporten giver dig et klart og dokumenteret overblik over, hvilke forbedringer der vil give den største besparelse og den bedste indeklimakomfort.
                </p>
              </div>

              <div className="p-4 rounded-2xl bg-[#11463A] text-white flex flex-col sm:flex-row sm:items-center justify-between gap-4 shadow-sm">
                <div>
                  <span className="text-xs uppercase text-emerald-300 font-semibold block">Pris for undersøgelse:</span>
                  <span className="text-2xl font-bold text-white">Fra 2.500 kr. inkl. moms</span>
                </div>
                <div className="flex gap-2">
                  <a
                    href="#kontakt"
                    className="px-5 py-2.5 rounded-full bg-white text-stone-900 font-bold text-xs hover:bg-stone-100 transition-colors"
                  >
                    Kontakt os
                  </a>
                  <Link
                    to="/prisberegner"
                    className="px-5 py-2.5 rounded-full bg-emerald-600 text-white font-bold text-xs hover:bg-emerald-500 transition-colors"
                  >
                    Beregn pris
                  </Link>
                </div>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-3xl overflow-hidden shadow-xl border-4 border-stone-100 bg-stone-100 aspect-16/11">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07508-2.jpg"
                  alt="Termografisk rådgivning og inspektion"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. HVAD ER TERMOGRAFI AF BYGNINGER? */}
      <section className="py-16 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl space-y-4 mb-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight">
              Hvad er termografi af bygninger?
            </h2>
            <div className="space-y-3 text-stone-600 text-sm sm:text-base leading-relaxed">
              <p>
                Termografi af bygninger er en metode, hvor man ved hjælp af et specielt varmekamera kan se temperaturforskelle på en bygnings overflader. Kameraet registrerer infrarød stråling, som ikke kan ses med det blotte øje, og omsætter det til farvebilleder, hvor varme og kulde fremstår tydeligt.
              </p>
              <p>
                Med termografi kan man hurtigt og præcist afsløre områder, hvor varmen slipper ud, eller hvor kulde trænger ind. Det bruges typisk til at finde:
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {applications.map((app, idx) => (
              <div
                key={idx}
                className="p-5 rounded-2xl bg-[#FAF9F6] border border-stone-200 flex flex-col justify-between"
              >
                <div>
                  <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-800 flex items-center justify-center text-base mb-3">
                    <i className={`fa-solid ${app.icon}`} aria-hidden="true"></i>
                  </div>
                  <h3 className="font-bold text-stone-900 text-sm">{app.title}</h3>
                  <p className="text-xs text-stone-600 mt-2 leading-relaxed">{app.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 3. SE DET SKJULTE MED TERMOGRAFI (FORDELSBOKSE) */}
      <section className="py-16 sm:py-20 bg-stone-50 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-6 space-y-5">
              <h2 className="text-3xl font-extrabold text-stone-900 tracking-tight">
                Se det skjulte med termografi
              </h2>
              <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
                Med termografi får du et tydeligt billede af, hvor varmen forsvinder fra din bolig eller virksomhed. Vores varmekamera afslører kuldebroer, utætheder og dårlig isolering – problemer, der ellers er usynlige for øjet. En termografisk undersøgelse giver dig:
              </p>

              <div className="space-y-3 pt-2">
                <div className="flex items-center gap-3 p-4 rounded-xl bg-white border border-stone-200 shadow-2xs">
                  <span className="text-emerald-600 font-bold text-base">✔️</span>
                  <span className="font-semibold text-stone-900 text-sm">Klar dokumentation på bygningens tilstand</span>
                </div>
                <div className="flex items-center gap-3 p-4 rounded-xl bg-white border border-stone-200 shadow-2xs">
                  <span className="text-emerald-600 font-bold text-base">✔️</span>
                  <span className="font-semibold text-stone-900 text-sm">Mulighed for at spare på varmeregningen</span>
                </div>
                <div className="flex items-center gap-3 p-4 rounded-xl bg-white border border-stone-200 shadow-2xs">
                  <span className="text-emerald-600 font-bold text-base">✔️</span>
                  <span className="font-semibold text-stone-900 text-sm">Bedre komfort og indeklima</span>
                </div>
              </div>

              <p className="text-xs text-stone-600 italic pt-2">
                Kontakt os i dag og få en professionel termografi af din bygning – så du ved præcis, hvor du skal sætte ind.
              </p>
            </div>

            <div className="lg:col-span-6">
              <div className="rounded-3xl overflow-hidden shadow-xl border-4 border-white aspect-4/3 bg-stone-200">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07564-2_9626acaf.jpg"
                  alt="Termografi facade undersøgelse"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3B. KOMBILØSNING: TRYKPRØVNING + TERMOGRAFI */}
      <section className="py-10 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mb-6 text-left">
            <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight">
              Trykprøvning og termografi – den optimale kombination
            </h2>
            <p className="text-stone-600 text-sm sm:text-base mt-2 leading-relaxed">
              Kombinationen af BlowerDoor-trykprøvning og termografisk måling giver den mest præcise fejlsøgning af bygningens tæthed og isoleringstilstand:
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            {[
              {
                icon: "fa-wind",
                title: "Utætheder og træk",
                desc: "Præcis lokalisering af utætheder ved vinduer, lofter og fodpaneler.",
              },
              {
                icon: "fa-layer-group",
                title: "Isoleringsfejl",
                desc: "Afslører manglende, forkert monteret eller sammenfaldet isolering.",
              },
              {
                icon: "fa-temperature-arrow-down",
                title: "Kuldebroer",
                desc: "Fanger samlinger der leder varme væk og giver risiko for kondens/skimmel.",
              },
              {
                icon: "fa-magnifying-glass",
                title: "Fejlsøgning i nybyggeri",
                desc: "Kvalitetssikring forud for aflevering eller 1- og 5-års eftersyn.",
              },
              {
                icon: "fa-fire-flame-curved",
                title: "Højt varmeforbrug",
                desc: "Få syn for sagen hvis varmeregningen er uforklarligt høj.",
              },
              {
                icon: "fa-file-circle-check",
                title: "Dokumentation",
                desc: "Fotodokumentation og termogrammer klar til udbedring eller forsikring.",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="bg-stone-50 border border-stone-200/80 rounded-xl p-4 text-left hover:border-[#165B4C]/40 transition-colors flex flex-col items-start"
              >
                <div className="w-10 h-10 rounded-lg bg-white border border-stone-200 flex items-center justify-center text-[#165B4C] mb-2.5 shadow-xs">
                  <i className={`fa-solid ${item.icon} text-sm`} aria-hidden="true" />
                </div>
                <h3 className="font-bold text-stone-900 text-xs sm:text-sm leading-snug mb-1">
                  {item.title}
                </h3>
                <p className="text-stone-600 text-xs leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-6 flex justify-end">
            <Link
              to="/trykproevning"
              className="inline-flex items-center text-sm font-semibold text-[#165B4C] hover:text-[#0f3f35] transition-colors gap-1.5"
            >
              Læs mere om BlowerDoor trykprøvning
              <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>

      {/* 4. CMS GALLERI FOR TERMOGRAFI */}
      <section className="py-16 bg-stone-50 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <GalleryViewer
            gallerySlug="termografi"
            title="Galleri: Termografiske målinger"
            subtitle="Infrarøde billeder og visualisering af kuldebroer og varmetab"
          />
        </div>
      </section>

      {/* 5. REVIEWS SLIDER */}
      <ReviewsSlider />

      {/* 6. KONTAKT FORMULAR */}
      <section id="kontakt" className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-5 space-y-5">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
                Kontakt os for termografi
              </h2>
              <div className="space-y-3 text-stone-600 text-sm leading-relaxed">
                <p>
                  For mere information eller for at starte et samarbejde, kontakt os på telefon <a href="tel:+4542499595" className="font-bold text-stone-900 whitespace-nowrap">42 49 95 95</a> , eller via e-mail <a href="mailto:info@etdanmark.com" className="font-bold text-stone-900 whitespace-nowrap">info@etdanmark.com</a> .
                </p>
                <p>
                  Vi rådgiver i hele Jylland og Fyn og svarer hurtigt på alle henvendelser.
                </p>
              </div>

              <div className="p-5 rounded-2xl bg-stone-50 border border-stone-200 space-y-2 text-xs text-stone-700">
                <p className="font-semibold text-stone-900">ET Danmark ApS</p>
                <p>Bjerrevej 62 A, 8700 Horsens</p>
                <p>Holbækvej 21C, 4200 Slagelse</p>
                <p>Telefon: 42 49 95 95</p>
              </div>
            </div>

            <div className="lg:col-span-7">
              <ContactForm
                defaultService="Termografi"
                title="Bestil termografi eller få et uforpligtende tilbud"
                subtitle="Du kan let og hurtigt sende os en besked i nedenstående formular."
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
